import React from 'react';
import Container from 'common/components/UI/Container';
import { DemoFrame, DemoFrameNote, DemoMobilePreview } from '../../Custom/DemoEmbed';
import { Wrapper, Intro } from './interactivedemo.style';

const InteractiveDemoSection = () => (
  <Wrapper id="live_demo">
    <Container>
      <Intro>
        <span>INTERACTIVE DEMO</span>
        <h2>Click through CloudPouch 2.0 in your browser</h2>
        <p>
          The video at the top of the page shows AWS profiles, SSO and the AI assistant. Here,
          on sample data, try the Billing and Savings views yourself. Pick a
          profile, open a service for its cost details, run a Savings Scan,
          click through the savings flow and open the findings. It runs in your browser and sends nothing anywhere.
        </p>
      </Intro>
      <DemoFrame />
      <DemoFrameNote />
      <DemoMobilePreview />
    </Container>
  </Wrapper>
);

export default InteractiveDemoSection;
